import { get, post, put, Delete } from "../axios";

// 首页视频-查看
export const newsVideoView = (params) => get("/web/news/video/view", params);

// 首页视频-修改
export const newsVideoUpdate = (params) =>
  put("/web/news/video/update", params);
